import React, { useEffect } from "react";
import {
  useAddress,
  useChainId,
  useConnectionStatus,
  useDisconnect,
  useSwitchChain,
} from "@thirdweb-dev/react";
import { login } from "../../redux/auth/auth.action";
import { useDispatch, useSelector } from "react-redux";
import {
  changeCollectionContract,
  changeMarketplaceContract,
} from "../../redux/mint/mint.action";
import { resetStateAuth } from "../../redux/auth/auth.slicer";
const WalletConnect = ({ children }) => {
  const connectionStatus = useConnectionStatus();
  const switchChain = useSwitchChain();
  const wallet = useAddress();
  const disconnect = useDisconnect();
  const dispatch = useDispatch();
  const connectedChainId = useChainId();
  const { network } = useSelector((state) => state.mint);
  const selectedChain = JSON.parse(network);

  useEffect(() => {
    if (selectedChain.name === "Ethereum Mainnet") {
      dispatch(
        changeCollectionContract("0x1177B259517361d9C8776738a4a252C229EaFb61")
      );
      dispatch(
        changeMarketplaceContract("0x3dA4BEc570BcB31aEc88378492Cc057f00d76b30")
      );
    }
    if (selectedChain.name === "Avalanche C-Chain") {
      dispatch(
        changeCollectionContract("0x5221298c5aeb0a281d6645fd87368412cE0F0e08")
      );
      dispatch(
        changeMarketplaceContract("0xe1C7176Ec7A6A422979B59B9524Ed422e1039DD7")
      );
    }
    if (selectedChain.name === "Base") {
      dispatch(
        changeCollectionContract("0x5a271a801C8a7ff2436C77E0100D84c0815E9CE0")
      );
      dispatch(
        changeMarketplaceContract("0xC364ECf42D9407556bc20d18A10a3EC8FAA5dBcF")
      );
    }
    if (selectedChain.name === "Polygon Mainnet") {
      dispatch(
        changeCollectionContract("0x07b7F57b6eF32EE8496fE38Bf34e3eF7A458b3e5")
      );
      dispatch(
        changeMarketplaceContract("0x8bb47fec5419914971347551Af766e3993054167")
      );
    }
    if (connectionStatus === "connected") {
      if (connectedChainId !== selectedChain.chainId) {
        switchChain(selectedChain.chainId)
          .then(() => {
            dispatch(login({ wallet: wallet }));
          })
          .catch(() => {
            dispatch(resetStateAuth());
            return disconnect();
          });
      } else {
        dispatch(login({ wallet: wallet }));
      }
    } else {
      dispatch(resetStateAuth());
    }
  }, [
    connectionStatus,
    dispatch,
    wallet,
    switchChain,
    disconnect,
    connectedChainId,
    selectedChain,
  ]);
  return <>{children}</>;
};

export default WalletConnect;
